import React from 'react';
import { ArrowLeft, Search } from 'lucide-react';
import { ChatPainelGenerico } from './ChatPainelGenerico.jsx';

export const TrackView = (props) => {
    const { denunciaRastreada, trackedId, setTrackedId, buscaProtocolo, setBuscaProtocolo, buscaPin, setBuscaPin, handleBuscarDenuncia } = props;
    
    if (!trackedId) {
      return (
        <div className="max-w-md mx-auto mt-16 p-8 bg-white rounded-xl shadow-lg border border-slate-100 animate-fadeIn">
          <div className="text-center mb-6"><Search className="mx-auto text-blue-600 mb-3" size={40} /><h2 className="text-2xl font-bold text-slate-800">Acompanhar Situação</h2><p className="text-slate-500 text-sm mt-1">Insira seus dados para acessar o andamento do seu relato.</p></div>
          <form onSubmit={handleBuscarDenuncia} className="space-y-5">
            <div><label className="block text-sm font-semibold text-slate-700 mb-1">Número do Protocolo</label><input type="text" value={buscaProtocolo} onChange={(e) => setBuscaProtocolo(e.target.value.toUpperCase())} placeholder="RTA-XXXXXXXX" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none uppercase font-mono" required /></div>
            <div><label className="block text-sm font-semibold text-slate-700 mb-1">PIN de Acesso (6 dígitos)</label><input type="text" maxLength="6" value={buscaPin} onChange={(e) => setBuscaPin(e.target.value)} placeholder="000000" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none font-mono tracking-widest text-center" required /></div>
            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg shadow">Consultar Relato</button>
          </form>
        </div>
      );
    }
    return (
      <div className="max-w-6xl mx-auto mt-8 px-4">
        <button onClick={() => setTrackedId(null)} className="text-blue-600 text-sm font-medium mb-4 flex items-center gap-1 hover:underline"><ArrowLeft size={16} /> Voltar para a busca</button>
        <ChatPainelGenerico {...props} denuncia={denunciaRastreada} isAdminView={false} />
      </div>
    );
};
